import { Skeleton } from '../Skeleton/Skeleton';
import { Fragment } from 'react/jsx-runtime';
import { Table } from './Table';

interface Props {
  cols: number;
  rows?: number;
}

export function Loading({ cols, rows = 3 }: Props) {
  return (
    <Fragment>
      {[...Array(rows).keys()].map(row => (
        <Table.Row key={`t-loading-row-${row}`}>
          {[...Array(cols).keys()].map(col => (
            <Table.Col key={`t-loading-col-${col}`}>
              <Skeleton style={{ width: '70%' }} />
            </Table.Col>
          ))}
        </Table.Row>
      ))}
    </Fragment>
  );
}
